import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions-col" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_gain_configuration_versions_modal = _resolveComponent("gain-configuration-versions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_card, { "no-header": "" }, {
      body: _withCtx(() => [
        _createVNode(_component_el_row, { class: "items-stretch broker-row" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString($props.configuration.brokerId), 1),
                _createElementVNode("h3", {
                  class: "body-1 cursor-pointer mt-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openVersionModal && $setup.openVersionModal(...args)))
                }, _toDisplayString(_ctx.$t('currentVersion') + ': ' + $props.configuration.version), 1),
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  content: _ctx.$t('disableBrokerSftpNote')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: $setup.form.enabled,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.enabled) = $event)),
                      "active-text": _ctx.$t('enabledCapitalized'),
                      "inactive-text": _ctx.$t('disabledCapitalized'),
                      onChange: $setup.handleChangeEnabled
                    }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 15 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: $setup.form,
                  rules: $setup.formRules,
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('connectionDetails')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('hostName'),
                      prop: "hostName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.hostName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.hostName) = $event)),
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChangeHostName
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('userName'),
                      prop: "userName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.userName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.userName) = $event)),
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChangeUserName
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('passwordKeyName'),
                      "validate-event": false,
                      prop: "passwordKeyName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          content: _ctx.$t('brokerSftpPasswordSshKeysTooltipMessage')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.passwordKeyName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.passwordKeyName) = $event)),
                              "validate-event": false,
                              size: "small",
                              onChange: $setup.handleChangePasswordKeyName
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('sshKeyKeyName'),
                      prop: "sshKeyKeyName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          content: _ctx.$t('brokerSftpPasswordSshKeysTooltipMessage')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.sshKeyKeyName,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.sshKeyKeyName) = $event)),
                              "validate-event": false,
                              size: "small",
                              onChange: $setup.handleChangeSshKeyKeyName
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('port'),
                      prop: "port"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: $setup.form.port,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.port) = $event)),
                          size: "small",
                          min: 1,
                          max: 65535,
                          precision: 0,
                          step: 1,
                          "value-on-clear": null,
                          onChange: $setup.handleChangePort
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('fileFetchingSettings')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('scanPath'),
                      prop: "scanPath"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          content: _ctx.$t('scanPathOptionalTooltipContent')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.scanPath,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.scanPath) = $event)),
                              "validate-event": false,
                              size: "small",
                              onChange: $setup.handleChangeScanPath
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      content: _ctx.$t('fileFiltersTooltipContent')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_divider, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('fileFilters')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    (!$setup.form.fileFilters.length)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          class: "mt-2 cursor-pointer",
                          onClick: $setup.addFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" + " + _toDisplayString(_ctx.$t('add')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.fileFilters, (ff, idx) => {
                            return (_openBlock(), _createBlock(_component_el_form_item, {
                              key: `ff-${idx}`,
                              class: "mb-2",
                              prop: `fileFilters.${idx}.namePattern`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, {
                                  gutter: 10,
                                  class: "filter-row"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 22 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: ff.namePattern,
                                          "onUpdate:modelValue": ($event: any) => ((ff.namePattern) = $event),
                                          size: "small",
                                          clearable: "",
                                          onChange: ($event: any) => ($setup.handleFilterChange(idx, ff.namePattern))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, { span: 2 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "default",
                                          size: "small",
                                          onClick: ($event: any) => ($setup.removeFilter(idx))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["prop"]))
                          }), 128)),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: $setup.addFilter
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" + " + _toDisplayString(_ctx.$t('add')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "actions-col-wrapper"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/icons/new/delete.svg`),
                    height: "20",
                    width: "20",
                    class: "action-icon cursor-pointer",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.deleteItem && $setup.deleteItem(...args)))
                  }, null, 8, _hoisted_2),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    onClick: $setup.saveItem
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_gain_configuration_versions_modal, {
      modelValue: $setup.showVersionModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.showVersionModal) = $event)),
      "configuration-versions": $setup.props.configurationHistory,
      onRestore: $setup.handleRestore,
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.showVersionModal = false))
    }, null, 8, ["modelValue", "configuration-versions", "onRestore"])
  ], 64))
}